function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".\\34 cf1cd61-86b9-47d7-8b19-9ead3e938062{fill:none;stroke:#f7941d;stroke-miterlimit:10;stroke-width:9px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "logo");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "1bbd1736-f956-4a9d-9526-da87540ab560",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "cfb69572-831f-406a-b209-224d654cc191",
  "data-name": "Layer 1-2"
}, React.createElement("path", {
  className: "4cf1cd61-86b9-47d7-8b19-9ead3e938062",
  d: "M43.7,130.3V28.7L88.9,73.9l33.7-43L154.9,79l49.3-55.4V142.9a175,175,0,0,1-2.5,30.7,38.1,38.1,0,0,1-35.9,31.1H42.9a28.3,28.3,0,0,1-20-8.3h0a33.4,33.4,0,0,1,0-47.2h0a16.5,16.5,0,0,1,11.7-4.9h127a16.6,16.6,0,0,1,11.8,4.8h0c3.2,3.2,4.6,8.7,4.4,14.1a11.5,11.5,0,0,1-5.9,9.5,12,12,0,0,1-11.7-.1l-5.6-3.1",
  transform: "translate(-8.6 -11.8)"
}), React.createElement("path", {
  className: "4cf1cd61-86b9-47d7-8b19-9ead3e938062",
  d: "M165.8,204.6c-14.8-1.9-27.7-15.1-27.7-30.1a30,30,0,0,1,26.2-29.7",
  transform: "translate(-8.6 -11.8)"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "7da596ac-5fe5-44f8-8ac8-28dd094b1b64",
    "data-name": "Layer 1",
    viewBox: "0 0 200.2 197.4",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f33017a7.svg";
export { ForwardRef as ReactComponent };